module.exports = __webpack_public_path__ + "img/docx.9ac7c158.png";